import { render, staticRenderFns } from "./RecoveryTimeRequest.vue?vue&type=template&id=37d9ecbc&scoped=true&"
import script from "./RecoveryTimeRequest.vue?vue&type=script&lang=js&"
export * from "./RecoveryTimeRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d9ecbc",
  null
  
)

export default component.exports